/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { TasksApiConfiguration as __Configuration } from '../tasks-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter, tap } from 'rxjs/operators';

import { ListQueryResultTaskTypeInfo } from '../models/list-query-result-task-type-info';
import { CreateTaskTypeCommand } from '../models/create-task-type-command';
import { UpdateTaskTypeCommand } from '../models/update-task-type-command';
@Injectable({
  providedIn: 'root',
})
class TaskTypeService extends __BaseService {
  static readonly GetAllPath = '/api/tasks/types';
  static readonly CreateTaskTypePath = '/api/tasks/types';
  static readonly GetUpdateTaskTypePath = '/api/tasks/types/{id}/update';
  static readonly UpdateTaskTypePath = '/api/tasks/types/{id}/update';
  static readonly DeleteTaskTypePath = '/api/tasks/types/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `TaskTypeService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAllResponse(params: TaskTypeService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultTaskTypeInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.CatagoryId != null) __params = __params.set('CatagoryId', params.CatagoryId.toString());
    if (params.IncludeDisabledFilter != false) __params = __params.set("IncludeDisabledFilter", params.IncludeDisabledFilter); //This activates disabled types filter
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/types`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultTaskTypeInfo>;
      })
    );
  }
  /**
   * @param params The `TaskTypeService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAll(params: TaskTypeService.GetAllParams): __Observable<ListQueryResultTaskTypeInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultTaskTypeInfo)
    );
  }

  /**
   * @param command undefined
   */
  CreateTaskTypeResponse(command?: CreateTaskTypeCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/tasks/types`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateTaskType(command?: CreateTaskTypeCommand): __Observable<null> {
    return this.CreateTaskTypeResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateTaskType(id: string): __Observable<UpdateTaskTypeCommand> {
    return this.http.get<any>(this.rootUrl + `/api/tasks/types/${id}/update`).pipe(
      __map(_r => _r as UpdateTaskTypeCommand)
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  // GetUpdateTaskType(id: string): __Observable<UpdateTaskTypeCommand> {

  //   return this.GetUpdateTaskTypeResponse(id).pipe(
  //     __map(_r =>_r as UpdateTaskTypeCommand)
  //   );
  // }

  /**
   * @param params The `TaskTypeService.UpdateTaskTypeParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateTaskTypeResponse(params: TaskTypeService.UpdateTaskTypeParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/tasks/types/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `TaskTypeService.UpdateTaskTypeParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateTaskType(params: TaskTypeService.UpdateTaskTypeParams): __Observable<null> {
    return this.UpdateTaskTypeResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  DeleteTaskTypeResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/tasks/types/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteTaskType(id: string): __Observable<null> {
    return this.DeleteTaskTypeResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module TaskTypeService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
    CatagoryId?:string;
    IncludeDisabledFilter?:boolean;
  }

  /**
   * Parameters for UpdateTaskType
   */
  export interface UpdateTaskTypeParams {
    id: string;
    command?: UpdateTaskTypeCommand;
  }
}

export { TaskTypeService }
